import { cn } from "@/lib/utils";
import { motion, useMotionValue } from "framer-motion";
import { useLocation } from "react-router-dom";
import { IconContainer } from "./IconContainer";
import { NavItem } from "./types";

interface FloatingDockDesktopProps {
  items: NavItem[];
  className?: string;
}

export function FloatingDockDesktop({ items, className }: FloatingDockDesktopProps) {
  let mouseX = useMotionValue(Infinity);
  const location = useLocation();

  return (
    <motion.div
      onMouseMove={(e) => mouseX.set(e.pageX)}
      onMouseLeave={() => mouseX.set(Infinity)}
      className={cn(
        "mx-auto hidden md:flex h-16 gap-4 items-end rounded-2xl bg-gray-50 dark:bg-neutral-900 px-4 pb-3 w-fit shadow-lg border",
        className
      )}
    >
      {items.map((item) => (
        <IconContainer 
          mouseX={mouseX} 
          key={item.title} 
          {...item} 
          isActive={location.pathname === item.href}
        />
      ))}
    </motion.div>
  );
}